import { notification } from "antd";
import Helper from "../../Helper";
import { CalendarEvent } from "../../models/CalendarEvent";

export function getCalendarEventAttachments(
    teamSubdomain: string,
    projectToken: string,
    calendarEvent: CalendarEvent
): Promise<any[]> {
    const url = `${Helper.baseUrlAltSubdomain(teamSubdomain)}/projects/${projectToken}/calendar_events/${calendarEvent.id}/attachments`;

    return Helper.plotFetch(url, {}, true)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            throw Error("Failed to get attachments");
        })
        .then((response) => {
            return response;
        })
        .catch(() => {
            return [];
        });
}

export function createCalendarEventAttachment(
    teamSubdomain: string,
    projectToken: string,
    calendarEvent: CalendarEvent,
    form_data: FormData
): Promise<any> {
    const url = `${Helper.baseUrlAltSubdomain(teamSubdomain)}/projects/${projectToken}/calendar_events/${calendarEvent.id}/attachments`;

    const options = {
        method: "POST",
        body: form_data,
    };
    return Helper.plotFetch(url, options, true)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            throw Error("Failed to create attachment");
        })
        .then((response) => {
            return response;
        })
        .catch(() => {
            return null;
        });
}

export function deleteCalendarEventAttachment(
    teamSubdomain: string,
    projectToken: string,
    calendarEvent: CalendarEvent,
    attachmentId: number
): Promise<any> {
    const url = `${Helper.baseUrlAltSubdomain(teamSubdomain)}/projects/${projectToken}/calendar_events/${calendarEvent.id}/attachments/${attachmentId}`;

    const options = {
        method: "DELETE",
        body: JSON.stringify({}),
    };
    return Helper.plotFetch(url, options, true)
        .then((response) => {
            if (response.ok) {
                return response.json();
            }

            throw Error("Failed to delete attachment");
        })
        .then((response) => {
            return response;
        })
        .catch(() => {
            notification.error({
                message: "Error Deleting Attachment",
                description: "Failed to delete attachment",
            });
            return null;
        });
}
